export enum ESubmissionStatus {
    Idle = 'idle',
    Submitting = 'submitting',
    Success = 'success',
    Error = 'error',
}

export interface IFeedbackFormModel {
    email: string;
    message: string;
    captchaToken: string;
}

export interface IFeedbackSubmitPayload {
    email: string;
    message: string;
    'cf-turnstile-response': string;
    subject: string;
    from_name: string;
    config_json?: string;
    share_url?: string;
}

export type ITurnstileSize = 'normal' | 'compact' | 'flexible' | 'invisible';

export interface ITurnstileRenderConfig {
    sitekey: string;
    size?: ITurnstileSize;
    theme?: 'light' | 'dark' | 'auto';
    language?: string;
    callback: (token: string) => void;
    'expired-callback'?: () => void;
    'error-callback'?: () => void;
}

export interface ITurnstileApi {
    render: (element: HTMLElement, config: ITurnstileRenderConfig) => string | undefined;
    reset: (widgetId?: string) => void;
    remove: (widgetId: string) => void;
}
